module.exports = __webpack_public_path__ + "static/img/va-banner-e.1c0fbf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/va-banner-e.png
// module id = hkH7
// module chunks = 1